//Home

import axios from 'axios';

//this grabs all data for a poem's course upon mounting
export function fetchHomePoets() {
  const url = '/api/poets/home';
  const request = axios.get(url);

  return function(dispatch) {
    request.then(function(response) {

      dispatch({
        type: 'FETCH_HOME_POETS',
        homePoets: response.data
      });

    }).catch((error) => console.log(error));
  };
}

export function fetchPoet(poetID) {
  const url = `/api/poet/${poetID}`;
  const request = axios.get(url);

  return function(dispatch) {
    request.then(function(response) {

      dispatch({
        type: 'FETCH_POET',
        poet: response.data
      });

    }).catch((error) => console.log(error));
  };
}

export function fetchAllPoets() {
  const url = '/api/poets';
  const request = axios.get(url);

  return function(dispatch) {
    request.then(function(response) {

      dispatch({
        type: 'FETCH_ALL_POETS',
        allPoets: response.data
      });

    }).catch((error) => console.log(error));
  }
}

export function unmountPoet() {
  return {
    type: 'UNMOUNT_POET'
  }
}

// Moved to course

// export function fetchUser() {
//   const request = axios.get('/api/current_user');
//
//   return function(dispatch){
//     request.then((res) => {
//       dispatch({ type: 'FETCH_USER', user: res.data });
//     }).catch((error) => console.log(error));
//   }
// };
//
// export function logOut(){
//   window.location.replace('/api/logout');
//   return { type: 'LOGOUT_USER'};
// }



// WEBPACK FOOTER //
// ./src/actions/home.js